<template>
    <div>

      <div class="w-full d-flex justify-content-end">
            <a-button class="mx-2 mb-2" type="primary" @click="getDrivers()"><a-icon type="sync" /></a-button>
        </div>
        <a-table v-if="!driversLoading" :columns="userColumns" :data-source="drivers">
                      <p slot="name" class="mb-0" slot-scope="data">{{data.first_name}} {{ data.last_name }}
                        <a-tag v-if="data.hasShifts" color="green">
                          Heeft shift
                        </a-tag>
                        <a-tag v-else color="red">
                          Geen shift
                        </a-tag>
                      </p>
                      <a slot="acties" slot-scope="data">
                        <div class="w-full d-flex justify-content-between">
                          <div>
                            <a-button class="m-1" @click="openShiftByDateModal(data)" type="primary">Nieuwe shift</a-button>
                            <a-button class="m-1" v-if="data.hasShifts" @click="openListShiftsModal(data)" type="primary">Bekijk Shifts</a-button>
                          </div>
                          <a-dropdown-button v-if="false" @click="openEditUserModal(data)">
                            <a-icon type="setting" />
                            <a-menu slot="overlay">
                              <a-menu-item key="1" @click="openUserPasswordResetModal(data)"> <a-icon type="mail" />Wachtwoord vergeten email verzenden </a-menu-item>
                            </a-menu>
                          </a-dropdown-button>
                        </div>
                  </a>
        </a-table>
        <div v-if="driversLoading"  class="w-100 d-flex justify-content-center align-items-center">
          <a-spin size="large" />
        </div>

        <a-modal
            title="Shift activeren"
            :visible="shiftByDateModalVisible"
            cancel-text="Annuleren"
            @cancel="cancelShiftByDateModal"
            :okButtonProps="{style: { display: 'none' }}"
        >
            <p class="input-label">Datum</p>
            <a-date-picker class="mb-2" v-model="shiftByDateModalData.date" placeholder="Datum" />
            <a-button class="ml-2" @click="createShiftByDate" type="primary">Activeer</a-button>
            <hr />
            <div class="d-flex justify-content-between flex-column">
              <a-button class="my-1" @click="quickActionShiftByDate(0)" type="primary">Vandaag</a-button>
              <a-button class="my-1" @click="quickActionShiftByDate(1)" type="primary">Morgen</a-button>
              <a-button class="my-1" @click="quickActionShiftByDate(2)" type="primary">Overmorgen</a-button>
            </div>
          
        </a-modal>
        <a-modal
            title="Shifts"
            :visible="listShiftsModalVisible"
            cancel-text="Sluiten"
            @cancel="closeListShiftsModal"
            :okButtonProps="{style: { display: 'none' }}"
        >
            <a-table :columns="listShiftsModalColumns" :data-source="listShiftsData.driverShifts">
              <p slot="start" class="mb-0" slot-scope="data"style="text-transform: capitalize;">{{ moment(data.start).locale('nl').format('LLL') }}</p>
              <p slot="end" class="mb-0" slot-scope="data" style="text-transform: capitalize;">{{ moment(data.end).locale('nl').format('LLL') }}</p>
              <a slot="acties" slot-scope="data">
                <a-button class="m-1" type="danger" @click="setDriverInactive(data)">Verwijderen</a-button>
              </a>
            </a-table>
        </a-modal>
    </div>
</template>

<script>
import moment from 'moment'
const userColumns = [
  {
    title: 'Naam',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Acties',
    scopedSlots: { customRender: 'acties' },
  },
]
const listShiftsModalColumns = [
  {
    title: 'Starttijd',
    scopedSlots: { customRender: 'start' },
  },
  {
    title: 'Eindtijd',
    scopedSlots: { customRender: 'end' },
  },
  {
    title: 'Acties',
    scopedSlots: { customRender: 'acties' },
  },

]

export default {

  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      userColumns,
      driversLoading: false,
      drivers: [],
      shiftByDateModalVisible: false,
      shiftByDateModalData: {},
      listShiftsModalColumns,
      listShiftsData: [],
      listShiftsModalVisible: false,
    }
  },
    mounted() {
        this.getDrivers()
    },
  methods: {
    getDrivers() {
        this.driversLoading = true
        this.$axios.get('/driverShifts', {
            headers: {
            'Authorization': `Bearer ${this.user.user.token}`,
            } }).then(response => {
            this.driversLoading = false
            this.drivers = response.data
        })
    },
    createShiftByHours(user_id, hours) {
      this.$axios.post('/driverShifts/create', {
        user_id,
        hours,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getDrivers()
      });
    },
    openShiftByDateModal(data) {
      this.shiftByDateModalData = data
      this.shiftByDateModalVisible = true
    },
    createShiftByDate(){
      this.$axios.post('/driverShifts/createByDate', {
        user_id: this.shiftByDateModalData.id,
        date: this.shiftByDateModalData.date,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getDrivers()
        this.shiftByDateModalVisible = false;
        this.shiftByDateModalData = {};
      });
    },
    quickActionShiftByDate(days) {
      this.shiftByDateModalData.date = moment().add(days, 'days').format('YYYY-MM-DD')
      this.createShiftByDate()
    },
    cancelShiftByDateModal() {
      this.shiftByDateModalVisible = false
      this.shiftByDateModalData = {}
    },
    openListShiftsModal(data) {
      this.listShiftsData = data;
      this.listShiftsModalVisible = true
    },
    closeListShiftsModal() {
      this.listShiftsModalVisible = false
      this.shiftByDateModalData = []
    },

    setDriverInactive(shift) {
      this.$axios.post('/driverShifts/delete-shift', {
        shift_id: shift.id,
      }, {
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        },
      }).then(response => {
        this.getDrivers();
        this.listShiftsModalVisible = false
        this.listShiftsData = []
      });
    },

  }
}

</script>